import { type MarkerType, type PositionHistoryClickItem } from '#/types/messages/positions-history-payload.types';

import { type ChartSize, DeviceType, type LineDragEndPayload, ParentApp } from './device.types';

export class AndroidTradingService extends ParentApp {
  serviceName = 'AndroidTradingService';

  isDevice(device: DeviceType): boolean {
    return device === DeviceType.AndroidNative;
  }

  protected get control() {
    return window.AndroidNative;
  }

  onAppReadyListenMessages() {
    this.control?.onTradingViewChartLoaded?.();
  }

  setChartSize(size: ChartSize) {
    return this.control?.setChartSize?.(size);
  }

  openUiElementsDisplayConfiguration(): void {
    this.control?.openTradeConfiguration?.();
  }

  onHmrInfoButtonPressed() {
    this.control?.hmrIconPressed?.();
  }

  onPositionsHistoryMarkerPressed(positions: PositionHistoryClickItem[], markerType: MarkerType) {
    this.control?.positionsHistoryMarkerPressed?.(positions, markerType);
  }

  requestPositionsHistory(range: { from: number; to: number }) {
    this.control?.requestPositionsHistory?.(range);
  }

  onLineDragEnd(payload: LineDragEndPayload): void {
    this.control?.onLineDragEnd?.(payload);
  }

  onSymbolChanged(symbol: string) {
    this.control?.symbolChanged?.(symbol);
  }
}
